// extracted by mini-css-extract-plugin
export default {"versionSelectorSectionWrapper":"versionWrapper_versionSelectorSectionWrapper__Oxzb-"};